import { createContext } from 'react';

export const ConstantAPISContext = createContext({
  yilListe: [] as any[],
  mahalleListe: [] as any[],
  menuList: [] as any[],
  menuListAll: [] as any[],
  bolgeListe: [] as any[],
  menuListAltMenu: [] as any[],
  kullaniciVarmi: false,
  setKullaniciVarmi: (value: boolean) => {},
  duyurularListe: [] as any[],
  setDuyurularListe: (value: any[]) => {},
});
